import React from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';

import ScrollToTop from './util/ScrollToTop';
import Layout from './hoc/Layout/Layout';
import Main from './components/Main/Main';
import Types from './components/Types/Types';
import Contact from './components/Contact/Contact';

function App() {

  return (
    <Layout>
      <ScrollToTop />
      <Switch>
        <Route path="/tipovi" component={() => <Types title={'Tipovi'} />} />
        <Route path="/kontakt" render={() => <Contact title={'Kontakt'} />} />
        <Route path="/" exact component={() => <Main title={'Izvor vitalne vode'} />} />
        <Redirect to="/" />
      </Switch>
    </Layout>
  );
}

export default withRouter(App);
